import { ProjectStatus } from '@awork/features/project/models/project-status.model'
import { TaskStatus } from '@awork/features/task/models/task-status.model'
import { CustomFieldDefinitionLink } from '@awork/features/project/models/custom-field-definition-link.model'

interface IWorkflow {
  id: string
  name: string
  icon?: string
  isArchived: boolean
  isExternal?: boolean
  externalProjectIds?: string[]
  createdOn?: Date
  createdBy?: string
  updatedOn?: Date
  updatedBy?: string
  taskStatuses?: TaskStatus[]
  projectStatuses?: ProjectStatus[]
  customFieldDefinitionLinks?: CustomFieldDefinitionLink[]
}

/**
 * The workflow model in awork
 * A workflow is a reusable process definition covering task statuses, project statuses,
 * custom field definitions, and automations.
 */
export class Workflow implements IWorkflow {
  id: string
  name: string
  icon?: string
  isArchived: boolean
  isExternal?: boolean
  externalProjectIds?: string[]
  createdOn?: Date
  createdBy?: string
  updatedOn?: Date
  updatedBy?: string
  taskStatuses?: TaskStatus[]
  projectStatuses?: ProjectStatus[]
  customFieldDefinitionLinks?: CustomFieldDefinitionLink[]

  constructor(workflow: Partial<IWorkflow>) {
    Object.assign(this, workflow)

    if (this.taskStatuses) {
      this.taskStatuses = this.taskStatuses.map(status => new TaskStatus(status))
    }

    if (this.projectStatuses) {
      this.projectStatuses = this.projectStatuses.map(status => new ProjectStatus(status))
    }

    if (this.customFieldDefinitionLinks) {
      this.customFieldDefinitionLinks = this.customFieldDefinitionLinks.map(link => new CustomFieldDefinitionLink(link))
    }
  }
}
